import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

import { Image as ImageType } from '@application/Types/ComponentTypes'
import { Nullable } from '@application/Types/Opt'

import { Img } from './Image.styled'

export const isSvg = (image: ImageType): boolean => {
    return image.localFile.extension === 'svg'
}

export const isGif = (image: ImageType): boolean => {
    return image.localFile.extension === 'gif'
}

export const Image = ({
    image,
    className,
    width,
    height,
    loading = 'lazy',
}: {
    image: ImageType
    className?: string
    width?: number
    height?: number
    loading?: 'eager' | 'lazy'
}): Nullable<JSX.Element> => {
    if (!image.localFile) {
        return null
    }

    if (isSvg(image) || isGif(image)) {
        return (
            <Img
                src={image.localFile.publicURL}
                alt={image?.alternativeText}
                className={className}
                width={width}
                height={height}
            />
        )
    }

    const img = getImage(image.localFile)

    if (img) {
        return (
            <GatsbyImage
                image={img}
                title={image?.alternativeText}
                alt={image?.alternativeText}
                className={className}
                loading={loading}
            />
        )
    }

    return null
}
